export default __webpack_public_path__ + "images/7218d066ce2a9d01979160d8e6017e99-human_rights.webp";